// Helper function to find the parent action/task item
export const findParentActionContainer = (node: Node): HTMLDivElement | null => {
	const element = node.nodeType === Node.ELEMENT_NODE ? (node as HTMLElement) : node.parentElement;
	return element?.closest('[data-task-local-id]') ?? null;
};

export const includeEntireActionItemInSelection = (selection: Selection | null | undefined) => {
	if (!selection || selection.rangeCount === 0) {
		return selection;
	}
	const range = selection.getRangeAt(0);
	const { startContainer, endContainer } = range;

	const startInActionContainer = findParentActionContainer(startContainer);
	const endInActionContainer = findParentActionContainer(endContainer);
	if (startInActionContainer) {
		const newRange = document.createRange();
		newRange.selectNodeContents(startInActionContainer);
		return newRange;
	}
	if (endInActionContainer) {
		const newRange = document.createRange();
		newRange.selectNodeContents(endInActionContainer);
		return newRange;
	}
	return range;
};
